import axios, { AxiosError } from 'axios'
import config from 'config'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'
import { formatCurrency } from '../../utils/formatCurrency'
import { defaultLosJsonHeaders } from '../requestHeaders'

// ponytail: only the " - $amount" tail is rewritten; anything else renders unchanged
const COLLATERAL_AMOUNT_TAIL = /\s-\s\$([\d,]+(?:\.\d{1,2})?)\s*$/

function normalizeCollateralString(value?: string) {
    const match = value?.match(COLLATERAL_AMOUNT_TAIL)

    if (!value || !match) return value

    const amount = parseFloat(match[1].replace(/,/g, ''))

    // Use a function replacement so the '$' in formatCurrency output is not
    // interpreted as a capture-group backreference by String.replace.
    return value.replace(
        COLLATERAL_AMOUNT_TAIL,
        () => `: ${formatCurrency(amount)}`,
    )
}

export default async function getConsumerShoppedCollateralString(
    applicationUuid: string,
) {
    if (!applicationUuid) {
        throw new Error('Invalid application UUID')
    }

    try {
        const { data } = await axios.get(
            `${config.API_BASE_URL}/api/v3/applications/${applicationUuid}/consumer-shopped-collateral/first/`,
            {
                withCredentials: true,
                headers: defaultLosJsonHeaders(),
            },
        )

        return normalizeCollateralString(data.consumer_shopped_collateral)
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to get consumer shopped collateral: ${axiosError.message}`,
            axiosError,
            { applicationUuid },
        )

        throw new Error(axiosError.message)
    }
}
